import groupsAPI from '../../../api/groups'

const mapOrder = (order) => {
  switch (order) {
  case 'name':
    return 'name'
  case 'created':
    return 'created_at'
  default:
    return 'name'
  }
}

export default {
  async index({commit, rootState, state}, view) {
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta

    const params = {tenantID}

    if (typeof(meta.archived) !== 'undefined' && meta.archived !== null) {
      params.archived = meta.archived
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await groupsAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit, rootState}, {id}) {
    const tenantID = rootState.tenants.current.id
    const resp = await groupsAPI.show({tenantID, groupID: id})
    const group = resp.data.data
    commit('setCurrent', group)
  },

  async store({commit, state, rootState, dispatch}) {
    const tenantID = rootState.tenants.current.id

    const data = {
      name: state.forms.store.fields.name,
      description: state.forms.store.fields.name
    }

    // add any module relations
    let moduleData
    if (state.forms.relateModules.fields.moduleIDs !== null) {
      moduleData = {'modules': state.forms.relateModules.fields.moduleIDs}
    }

    // add any member relations
    let memberData
    if (state.forms.relateMembers.fields.memberIDs !== null) {
      memberData = {'tenant_users': state.forms.relateMembers.fields.memberIDs}
    }

    let newGroup, resp
    let addedRelations = false
    let success = true

    commit('forms/store/resetErrors')
    commit('forms/store/setSaving', true)
    commit('forms/store/resetSuccess')

    try {
      // store the group
      resp = await groupsAPI.store({tenantID, data})
      newGroup = resp.data.data

      // add any module relations
      if (moduleData) {
        await groupsAPI.relateModules({tenantID, groupID: newGroup.id, data: moduleData})
        addedRelations = true
      }

      // add any member relations
      if (memberData) {
        await groupsAPI.relateMembers({tenantID, groupID: newGroup.id, data: memberData})
        addedRelations = true
      }

      // update the resource if we added any relations
      if (addedRelations) {
        resp = await groupsAPI.show({tenantID, groupID: newGroup.id})
        newGroup = resp.data.data
      }

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/store/setErrors', errors)
        }
      }
    }

    commit('forms/store/setSaving', false)
    commit('forms/store/setSuccess', success)

    if (success) {
      commit('setCurrent', newGroup)
      dispatch('index', state._defaultView)
    }
  },

  async update({commit, state, rootState, dispatch}, {groupID, data}) {
    const tenantID = rootState.tenants.current.id

    if (!data) {
      data = {}

      if (state.forms.update.fields.name) {
        data.name = state.forms.update.fields.name
      }

      if (state.forms.update.fields.description) {
        data.description = state.forms.update.fields.description
      }
    }

    // add any module relations
    let moduleData
    if (state.forms.relateModules.fields.moduleIDs !== null) {
      moduleData = {'modules': state.forms.relateModules.fields.moduleIDs}
    }

    // add any member relations
    let memberData
    if (state.forms.relateMembers.fields.memberIDs !== null) {
      memberData = {'tenant_users': state.forms.relateMembers.fields.memberIDs}
    }

    let addedRelations = false
    let updatedGroup, resp
    let success = true

    commit('forms/update/resetErrors')
    commit('forms/update/resetSuccess')
    commit('forms/update/setSaving', true)

    try {
      // update the group
      resp = await groupsAPI.update({tenantID, groupID, data})
      updatedGroup = resp.data.data

      // add any module relations
      if (moduleData) {
        await groupsAPI.relateModules({tenantID, groupID: updatedGroup.id, data: moduleData})
        addedRelations = true
      }

      // add any member relations
      if (memberData) {
        await groupsAPI.relateMembers({tenantID, groupID: updatedGroup.id, data: memberData})
        addedRelations = true
      }

      // update the resource if we added any relations
      if (addedRelations) {
        resp = await groupsAPI.show({tenantID, groupID: updatedGroup.id})
        updatedGroup = resp.data.data
      }

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/update/setErrors', errors)
        }
      }
    }

    commit('forms/update/setSaving', false)
    commit('forms/update/setSuccess', success)

    if (success) {
      commit('upsert', {view: state._defaultView, entity: updatedGroup})
      commit('setCurrent', updatedGroup)
      dispatch('index', state._defaultView)
    }
  },

  async restore({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const data = { 'is_deleted': false }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await groupsAPI.update({tenantID, groupID: id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  },

  async archive({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await groupsAPI.destroy({tenantID, groupID: id})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/groups/actions.js